module.exports = __webpack_public_path__ + "img/Character_Lisa_Thumb.b9e5416c.png";